import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import candidatePicture from '../../assets/icons/avatar-placeholder.svg';
import { ASSETS_URL } from '../../constants';
import { useTranslation } from 'react-i18next';
import { ChatCandidate } from '../../models/chat-candidate.interface';
import SearchWithButton from '../ui/SearchWithButton/SearchWithButton';

interface Props {
  candidates: ChatCandidate[];
  userClick: any;
  loadMore?: any;
  search: (value: string) => void;
  companyName: string;
}

const ChatCandidateList = ({
  candidates,
  userClick,
  loadMore,
  search,
  companyName,
}: Props) => {
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState<number | null>(null);

  const getSelectedUser = (user: ChatCandidate, i: number) => {
    setSelectedUser(i);
    userClick(user);
  };

  const getMoreUsers = () => {
    loadMore(true);
  };
  return (
    <div className='cb-candidate-list'>
      <div className='cb-candidate-list-crr-user mb-4'>
        <span>{companyName}</span>
      </div>
      <div className='cb-candidate-list-search'>
        <SearchWithButton
          search={search}
          placeholder={t('chatPage.searchPlaceholder')}
        />
      </div>
      <div className='cb-candidate-list-header'>
        <div className='d-flex align-items-center justify-content-between'>
          <label>{t('chatPage.candidates')}</label>
          {/* <button className='btn'>+</button> */}
        </div>
      </div>
      <div className='cb-candidate-list-body'>
        {candidates.map((candidate, index: number) => (
          <div
            onClick={() => getSelectedUser(candidate, index)}
            className={
              'cursor-pointer d-flex align-items-center candidate ' +
              `${index === selectedUser ? 'active' : ''}`
            }
            key={`${index}`}
          >
            <Image
              className='object-fit-cover'
              src={
                ASSETS_URL + (candidate.candidate_avatar || candidatePicture)
              }
            />
            <span className='d-block text-truncate'>
              {candidate.candidate_first_name} {candidate.candidate_last_name} -{' '}
              {candidate.offer_title}
            </span>
          </div>
        ))}
        {/* <div className='d-flex align-items-center justify-content-center'>
          <button
            className='btn btn-primary primary-btn-color px-5'
            onClick={getMoreUsers}
          >
            {t('chatPage.moreUsersButton')}
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ChatCandidateList;
